import { useState } from "react";
import { Share2, Link2, Check } from "lucide-react";
import { M } from "@/components/MarketingShell";

/** Fill these in once the accounts exist; follow links appear automatically. */
export const SOCIAL = {
  tiktok: "", // e.g. "https://www.tiktok.com/@tigerseyeapp"
  instagram: "", // e.g. "https://www.instagram.com/tigerseyeapp"
};

export function ShareBar({ title, url }: { title: string; url: string }) {
  const [copied, setCopied] = useState(false);

  async function share() {
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({ title, text: title, url });
      } catch {
        /* cancelled */
      }
    } else {
      await copy();
    }
  }

  async function copy() {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  const btn = "inline-flex items-center gap-2 rounded-md border px-3 py-2 text-sm";
  const style = { borderColor: M.RULE, color: M.INK };

  return (
    <div className="mt-10 flex flex-wrap items-center gap-3">
      <span className="text-sm" style={{ color: M.INK_FAINT }}>Share with a friend:</span>
      <button type="button" onClick={share} className={btn} style={style}>
        <Share2 className="h-4 w-4" /> Share
      </button>
      <button type="button" onClick={copy} className={btn} style={style}>
        {copied ? <Check className="h-4 w-4" /> : <Link2 className="h-4 w-4" />} Copy link
      </button>
      {SOCIAL.tiktok && (
        <a href={SOCIAL.tiktok} target="_blank" rel="noopener noreferrer" className={btn} style={style}>
          Follow on TikTok
        </a>
      )}
      {SOCIAL.instagram && (
        <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" className={btn} style={style}>
          Follow on Instagram
        </a>
      )}
    </div>
  );
}
